const initialState = {
  list: [],
  loading: true,
  error: null,
  benchmarks: {},
  benchmarksLoading: true,
  deepseekApiKey: '',
  deepseekApiKeyLoaded: false,
  /** Compat UI/reducers antiguos */
  geminiApiKey: '',
  geminiApiKeyLoaded: false,
};

export const fareMarketAdvisorreducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_FARE_RECOMMENDATIONS':
      return { ...state, loading: true, error: null };
    case 'FETCH_FARE_RECOMMENDATIONS_SUCCESS':
      return { ...state, loading: false, list: action.payload || [] };
    case 'FETCH_FARE_RECOMMENDATIONS_FAILED':
      return { ...state, loading: false, error: action.payload };
    case 'FETCH_FARE_BENCHMARKS':
      return { ...state, benchmarksLoading: true };
    case 'FETCH_FARE_BENCHMARKS_SUCCESS':
      return {
        ...state,
        benchmarks: action.payload || {},
        benchmarksLoading: false,
      };
    case 'FETCH_FARE_BENCHMARKS_FAILED':
      return { ...state, benchmarksLoading: false, error: action.payload };
    case 'FETCH_DEEPSEEK_API_KEY':
    case 'FETCH_GEMINI_API_KEY':
      return { ...state, deepseekApiKeyLoaded: false, geminiApiKeyLoaded: false };
    case 'FETCH_DEEPSEEK_API_KEY_SUCCESS':
    case 'FETCH_GEMINI_API_KEY_SUCCESS':
      return {
        ...state,
        deepseekApiKey: action.payload || '',
        geminiApiKey: action.payload || '',
        deepseekApiKeyLoaded: true,
        geminiApiKeyLoaded: true,
      };
    case 'FETCH_DEEPSEEK_API_KEY_FAILED':
    case 'FETCH_GEMINI_API_KEY_FAILED':
      return {
        ...state,
        deepseekApiKeyLoaded: true,
        geminiApiKeyLoaded: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
